import { render, staticRenderFns } from "./BaseMenuEntity.vue?vue&type=template&id=6eecd7e8"
import script from "./BaseMenuEntity.vue?vue&type=script&lang=ts"
export * from "./BaseMenuEntity.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports